let markBindingResolved
const bindingResolved = new Promise((resolve) => { markBindingResolved = resolve })

export const FRAME_BINDING_WAIT_LIMIT_MS = 5000

/**
 * Records that this add-in frame has finished resolving which AhaSlides slide (or whole
 * presentation) it is bound to, including the outcome that it is bound to nothing.
 * Safe to call any number of times; only the first call has an effect.
 */
export const markFrameBindingResolved = () => markBindingResolved()

/**
 * Resolves once markFrameBindingResolved has been called, or after `timeLimitMs`,
 * whichever comes first. Never rejects.
 */
export const waitForFrameBinding = (timeLimitMs = FRAME_BINDING_WAIT_LIMIT_MS) => {
  let timer
  const timeLimit = new Promise((resolve) => { timer = setTimeout(resolve, timeLimitMs) })
  return Promise.race([bindingResolved, timeLimit]).finally(() => clearTimeout(timer))
}
